const AddToCalendarActionSource = {
    SurfaceAction: 'Surface action', // Add to calendar from the surface action button
    ContextMenu: 'Context menu', // Add to calendar from the context menu item
};

export default AddToCalendarActionSource;
